import { Link } from 'react-router-dom'
import React, { useEffect, useState } from "react";
import axios from 'axios'
import Navbar from '../Navbar/Main';
import Footer from '../Footer/Main';
import ShareToolsBar from './ShareToolsBar';
import PageFeedbackCard from './PageFeedbackCard';
import './PublicationsMain.css'

export default function Service() {
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/publications')
      .then((response) => {
        setPost(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error('Failed to load publications:', error);
        setPost([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const publicationImageSrc = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `/${String(path).replace(/^\//, "")}`;
  };

  return (
    <>
    <Navbar/>
        <div className="stricky-header stricked-menu main-menu">
            <div className="sticky-header__content"></div>
        </div>
        <nav className="publications-bnr-breadcrumb-bar" aria-label="Breadcrumb">
          <div className="container">
            <ol className="publications-bnr-breadcrumb">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="publications-bnr-breadcrumb__sep" aria-hidden="true">
                ›
              </li>
              <li aria-current="page">Publications</li>
            </ol>
          </div>
        </nav>

        <section className="publications-bnr-hero" aria-labelledby="publications-bnr-heading">
          <div className="publications-bnr-hero__bg" aria-hidden="true" />
          <div className="publications-bnr-hero__overlay" aria-hidden="true" />
          <div className="container">
            <div className="publications-bnr-hero__card">
              <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
                <div className="flex-grow-1" style={{ minWidth: "min(100%, 16rem)" }}>
                  <h1 id="publications-bnr-heading" className="publications-bnr-hero__title">
                    Publications
                  </h1>
                  <span className="publications-bnr-hero__title-line" aria-hidden="true" />
                  <p className="small publications-bnr-hero__tagline mt-2 mb-0">Insights, reports and policy publications</p>
                </div>
                <div className="flex-shrink-0">
                  <ShareToolsBar pageTitle="Publications — National Bank of Rwanda" />
                </div>
              </div>
              <div className="publications-bnr-hero__lead">
                <p>
                  This section provides an overview of key publications that support transparency,
                  policy communication, and public awareness. Explore reports, economic reviews,
                  surveys and press releases related to the National Bank of Rwanda mandate.
                </p>
                <p>
                  Browse featured publications and all pages in this section below.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="service-five publications-zigzag pt-40 pb-30">
          <div className="container">
            {loading ? (
              <p className="text-center text-muted py-4">Loading…</p>
            ) : (
              post.map((p, i) => (
                <div
                  className={`row align-items-stretch align-items-lg-center g-4 publications-zigzag__row ${
                    i % 2 === 1
                      ? "flex-lg-row-reverse publications-zigzag__row--photo-left"
                      : "publications-zigzag__row--photo-right"
                  }`}
                  key={`zigzag-${p.id}`}
                >
                  <div className="col-12 col-lg-6 publications-zigzag__text">
                    <h3 className="publications-zigzag__title-heading">
                      <Link to={p.link} className="publications-zigzag__title">
                        {p.title}
                      </Link>
                    </h3>
                    <span className="publications-zigzag__title-line" aria-hidden="true" />
                    <p className="publications-zigzag__summary">{p.summary}</p>
                    <Link to={p.link} className="publications-zigzag__cta">
                      <span className="publications-zigzag__cta-icon" aria-hidden="true">
                        <i className="fa fa-angle-right" />
                      </span>
                      <strong className="publications-zigzag__cta-label">View {p.title}</strong>
                    </Link>
                  </div>
                  <div className="col-12 col-lg-6 publications-zigzag__media">
                    <Link to={p.link} className="publications-zigzag__img-link" aria-label={`Open ${p.title}`}>
                      <img
                        src={publicationImageSrc(p.image)}
                        alt={p.title}
                        className="publications-zigzag__img"
                        loading="lazy"
                        decoding="async"
                      />
                    </Link>
                  </div>
                </div>
              ))
            )}
          </div>
        </section>

        <Link to="#" data-target="html" className="scroll-to-target scroll-to-top"><i className="fa fa-angle-up"></i></Link>
        <Footer/>
    </>
  )
}

